import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import {
  convertFormatFromApiToJs,
  convertFormatFromApiToMoment,
} from "../actions/conversions";
import { COMMON_STATUS } from "../constants/status";
import { TSettings } from "../interface/ISettings";
import SettingsService from "../service/SettingsService";

import { RootState } from "../store/store";
import { logoutUser } from "./common";

export const resetSettings = createAction("settings/reset");

const _service = new SettingsService();

type SliceState = { value: TSettings; status: string; apiCallCount: number };

const initialState = {
  value: {},
  status: COMMON_STATUS.INITIAL,
  apiCallCount: 0,
} as SliceState;

export const getSettingsAsync = createAsyncThunk(
  "settings/getSettings",
  async (params: any) => {
    const response = await _service.getSettingsService(params);
    return response;
  }
);

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettingsStatus: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSettingsAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getSettingsAsync.fulfilled, (state, action) => {
        state.value = action.payload;
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(getSettingsAsync.rejected, (state) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetSettings, () => {
        return initialState;
      });
  },
});

export const { setSettingsStatus } = settingsSlice.actions;
export const getSettingsInfo = (state: RootState) => state.settings.value;
export const getSettingsStatus = (state: RootState) => state.settings.status;
export default settingsSlice.reducer;
